import React from 'react';
import Hero from '../components/sections/Hero';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeaturesSplit from '../components/sections/FeaturesSplit';
import Cta from '../components/sections/Cta';
import RelatedPages from '../components/sections/partials/RelatedPages';
import Seo from '../components/Seo';
import { useLanguage } from '../contexts/LanguageContext';
import { homeJsonLd } from '../seo/schema';

const meta = {
  en: {
    title: 'Moodle AI Chatbot for Your Course | E-comienza',
    description:
      'E-comienza builds AI chatbots for Moodle courses that answer student questions using only your course material, citing the unit and page, 24 hours a day.',
  },
  es: {
    title: 'Chatbot de IA para tu curso en Moodle | E-comienza',
    description:
      'E-comienza construye chatbots de IA para cursos en Moodle que responden a tus alumnos solo con el material del curso, citando la unidad y la página, 24 horas.',
  },
};

const Home = () => {
  const { lang } = useLanguage();
  const c = meta[lang] || meta.en;

  return (
    <>
      <Seo title={c.title} description={c.description} routeKey="home" jsonLd={homeJsonLd(lang)} />
      <Hero className="illustration-section-01" />
      <FeaturesTiles />
      <FeaturesSplit invertMobile topDivider imageFill className="illustration-section-02" />
      {/* Internal links to the service pages. Moodle is the positioning, so it
          comes first. */}
      <div className="container">
        <RelatedPages from="home" />
      </div>
      <Cta topDivider />
    </>
  );
};

export default Home;
